import React from 'react';
import { GiftIcon } from 'lucide-react';
import { volumes } from '../data/volumes';
import { bonuses } from '../data/bonuses';
export function WhatYouGet() {
  return <section id="volumes" aria-labelledby="volumes-heading" className="bg-navy-950" data-id="element-204" data-mp="zy98von9jpgs">
      <div className="mx-auto max-w-content px-4 py-20 sm:px-6 lg:py-28" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-205" data-mp="l5fs7zw993aj">
        <div className="max-w-3xl" data-id="element-206" data-mp="1drh19ij64ozj">
          
          <h2 id="volumes-heading" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-[2.75rem]" style={{
          paddingTop: "12px",
          paddingBottom: "12px",
          marginTop: "15px",
          marginBottom: "15px"
        }} data-id="element-207" data-mp="1dssdm6qoj529">
            দ্য আর্জেন্টাইন মাইন্ডসেট সিস্টেমে আপনি ঠিক কী কী পাচ্ছেন
          </h2>
          <p className="mt-4 text-lg text-white/70" data-id="element-208" data-mp="1wq30ssz1e81c">
            ৬টি সম্পূর্ণ ভলিউম + ৫টি এক্সক্লুসিভ বোনাস + লাইফটাইম অ্যাক্সেস।
          </p>
        </div>

        <ol className="mt-8 divide-y divide-white/10 border-y border-white/10" data-id="element-209" data-mp="2vfkhd27yhyne">
          {volumes.map(volume => <li key={volume.number} className="grid grid-cols-[3.25rem_1fr] items-center gap-x-4 gap-y-2 sm:grid-cols-[3.75rem_1fr] sm:gap-x-5 lg:grid-cols-[3.75rem_15rem_1fr]" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-210" data-mp="2qgzh52spfeyy">
              <img src={volume.cover} alt={`তোমো ${volume.number}-এর কভার: ${volume.title}`} width={240} height={300} loading="lazy" decoding="async" className="h-auto w-full rounded border border-white/15 object-cover shadow-[0_6px_18px_-10px_rgba(0,0,0,0.9)]" data-id="element-211" data-mp="30dm01m1gzvyc" />
              <div data-id="element-212" data-mp="3o3gajwybh8ff">
                <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-celeste-400" data-id="element-213" data-mp="3o3zjio5zomhb">
                  তোমো {volume.number}
                </p>
                <h3 className="mt-0.5 font-display text-base font-extrabold leading-tight tracking-tight text-white sm:text-lg" data-id="element-214" data-mp="1tpyl24ecq1hr">
                  {volume.title}
                </h3>
              </div>
              <p className="col-span-2 text-[13px] leading-snug text-white/70 lg:col-span-1" data-id="element-215" data-mp="2eg174t1j0ut9">
                {volume.description}
              </p>
            </li>)}
        </ol>

        <div className="mt-10" data-id="element-216" data-mp="2ng7gc2q6z8mm">
          <div className="rounded-2xl border border-celeste-500/25 bg-navy-900 p-6 sm:p-8" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-217" data-mp="2nf60lky8dxyk">
            <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-sun" data-id="element-218" data-mp="2xen35ti6rvqb">
              <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-219" data-mp="31f7314u59dg5" />
              আজ বিনামূল্যে পাচ্ছেন
            </p>
            <h3 className="mt-2 font-display text-xl font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-220" data-mp="36806lpdvmfqn">
              ৫টি এক্সক্লুসিভ বোনাস
            </h3>

            <ul className="mt-5 grid gap-4 sm:grid-cols-2" style={{
            paddingTop: "0px",
            paddingBottom: "0px"
          }} data-id="element-221" data-mp="3g54ubtndej9k">
              {bonuses.map(bonus => <li key={bonus.number} className="flex gap-3" data-id="element-222" data-mp="3l1vasi337gvi">
                  <img src={bonus.cover} alt={`বোনাস ${bonus.number}-এর কভার: ${bonus.name}`} width={64} height={64} loading="lazy" decoding="async" className="h-16 w-16 shrink-0 rounded border border-white/15 object-cover" data-id="element-223" data-mp="19hnt73hrrqwd" />
                  <div className="min-w-0" data-id="element-224" data-mp="zioq00frwngr">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-sun" data-id="element-225" data-mp="ujvci80hkwgl">
                      বোনাস {bonus.number}
                    </p>
                    <h4 className="mt-0.5 font-display text-[15px] font-extrabold leading-tight tracking-tight text-white" data-id="element-226" data-mp="1s96p6qddm4ow">
                      {bonus.name}
                    </h4>
                    <p className="mt-1 text-[13px] leading-snug text-white/70" data-id="element-227" data-mp="1ifhl828i3ydq">
                      {bonus.description}
                    </p>
                    <p className="mt-0.5 text-[13px] text-celeste-300" data-id="element-228" data-mp="2axbtq01uxtor">{bonus.detail}</p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}